import { useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { ConnectionStatus } from '../providers/RealTimeProvider';
import { useSubscription } from './useSubscription';
import {
  Bonus,
  Freespin,
  Jackpot,
  Lootbox,
  PlayerJackpotWin,
  PlayerTransaction,
} from '@/api/common';
import { TopPlayer } from '@/api/tournaments';
import { useCommonStore } from '@/store';

export const useGlobalRealTimeSubscriptions = () => {
  const {
    addPlayerJackpotWin,
    updateLootboxes,
    updateBonuses,
    updateFreespins,
    updatePlayerPayments,
    updateUserTournamentStatus,
  } = useCommonStore(
    useShallow((state) => ({
      addPlayerJackpotWin: state.addPlayerJackpotWin,
      updateLootboxes: state.updateLootboxes,
      updateBonuses: state.updateBonuses,
      updateFreespins: state.updateFreespins,
      updatePlayerPayments: state.updatePlayerPayments,
      updateUserTournamentStatus: state.updateUserTournamentStatus,
    }))
  );

  const handleJackpotChange = useCallback((data: Jackpot) => {
    useCommonStore.setState({ activeJackpot: data });
  }, []);

  const handleJackpotWin = useCallback(
    (data: PlayerJackpotWin) => addPlayerJackpotWin(data),
    [addPlayerJackpotWin]
  );

  const handleUpdateBonuses = useCallback(
    (data: Bonus) => updateBonuses(data),
    [updateBonuses]
  );
  const handleUpdateFreespins = useCallback(
    (data: Freespin) => updateFreespins(data),
    [updateFreespins]
  );
  const handleUpdateLootboxes = useCallback(
    (data: Lootbox) => updateLootboxes(data),
    [updateLootboxes]
  );
  const handleUpdatePayments = useCallback(
    (data: PlayerTransaction) => updatePlayerPayments(data),
    [updatePlayerPayments]
  );
  const handleUpdateTournamentStatus = useCallback(
    (data: TopPlayer) => updateUserTournamentStatus(data),
    [updateUserTournamentStatus]
  );

  const handleAnalytics = useCallback((context: any) => {
    console.log('######## $analytics#', context);
  }, []);

  // --- Public Subscriptions ---
  useSubscription<Jackpot>(
    'public:jackpots_changes',
    handleJackpotChange,
    ConnectionStatus.Public
  );

  // --- Private Subscriptions ---
  useSubscription<Bonus>('bonuses_changes', handleUpdateBonuses);
  useSubscription<Freespin>('freespins_changes', handleUpdateFreespins);
  useSubscription<Lootbox>('lootboxes_changes', handleUpdateLootboxes);
  useSubscription<PlayerTransaction>('payments_changes', handleUpdatePayments);
  useSubscription<TopPlayer>(
    'tournaments_statuses',
    handleUpdateTournamentStatus
  );
  useSubscription<PlayerJackpotWin>('jackpot_win_award', handleJackpotWin);
  useSubscription('$analytics', handleAnalytics);
};
